import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/userBlack.svg'
import _imports_1 from '@/assets/img/icon/crown-yellow.png'


const _hoisted_1 = { class: "flex flex-col items-left justify-between sm:flex-row sm:items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Pelanggan Retail")
], -1)
const _hoisted_3 = { class: "flex justify-between items-center card-customer" }
const _hoisted_4 = { class: "detail-category border-right-grey-lighten-3 flex-1 px-3" }
const _hoisted_5 = { class: "sm:flex items-center" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 mr-1",
  alt: "ret"
}, null, -1)
const _hoisted_8 = { class: "font-bold mr-4" }
const _hoisted_9 = {
  key: 0,
  class: "label-indigo rounded px-3 text-xs flex items-center",
  style: {"width":"fit-content"}
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-3 mr-1 py-1",
  alt: "ret"
}, null, -1)
const _hoisted_11 = { class: "flex items-center mt-2" }
const _hoisted_12 = { class: "text-subtitle2 color-blue-grey-darken-1 font-medium mr-3" }
const _hoisted_13 = { class: "swither px-6 flex items-center" }
const _hoisted_14 = { class: "mr-4" }
const _hoisted_15 = {
  key: 0,
  class: "text-center color-blue-grey pt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_DialogLevelUp = _resolveComponent("DialogLevelUp")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.searchInput,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchInput = $event)),
              onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.searchChange(_ctx.searchInput)), ["enter"])),
              placeholder: "Cari Disini ...",
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva,
              class: "mt-3 sm:mt-0"
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
          return (_openBlock(), _createBlock(_component_Card, {
            class: _ctx.classStatuscard(item),
            key: index
          }, {
            content: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode("h6", _hoisted_8, _toDisplayString(item.Fullname), 1)
                    ]),
                    (item.UserLevelId === 1)
                      ? (_openBlock(), _createBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createTextVNode(" " + _toDisplayString(item.UserLevelNama), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("p", _hoisted_12, _toDisplayString(item.Retail.PrimaryAddress ?? '-'), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode(_component_InputSwitch, {
                      class: "switch-og",
                      disabled: !_ctx.route.meta.permission.retail.update,
                      modelValue: item.IsActive,
                      "onUpdate:modelValue": ($event: any) => (item.IsActive = $event),
                      onChange: ($event: any) => (_ctx.changeIsActive(item))
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  (_ctx.route.meta.permission.retail.update || _ctx.route.meta.permission.retail.delete)
                    ? (_openBlock(), _createBlock("i", {
                        key: 0,
                        class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                        "aria:haspopup": "true",
                        onClick: ($event: any) => (_ctx.showDropDown($event, item))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128)),
        (_ctx.data.length === 0)
          ? (_openBlock(), _createBlock("p", _hoisted_15, "Pelanggan retail di kota anda belum ditambahkan"))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        (_ctx.data.length > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              rows: _ctx.filter.pageSize,
              totalRecords: _ctx.filter.totalRecords,
              onPage: _ctx.onPage
            }, null, 8, ["rows", "totalRecords", "onPage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        (_ctx.dataForm.UserLevelId !== 1)
          ? (_openBlock(), _createBlock(_component_ListCopyEditDel, {
              key: 0,
              levelupPelanggan: _ctx.route.meta.permission.retail.update,
              editPelanggan: _ctx.route.meta.permission.retail.update,
              onLevelupPelanggan: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showLevelUpDialog())),
              onEditPelanggan: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirectEdit(_ctx.dataForm)))
            }, null, 8, ["levelupPelanggan", "editPelanggan"]))
          : (_openBlock(), _createBlock(_component_ListCopyEditDel, {
              key: 1,
              editPelanggan: _ctx.route.meta.permission.retail.update,
              onEditPelanggan: _cache[5] || (_cache[5] = ($event: any) => (_ctx.redirectEdit(_ctx.dataForm)))
            }, null, 8, ["editPelanggan"]))
      ]),
      _: 1
    }, 512),
    (_ctx.isShowDialogLevelUp)
      ? (_openBlock(), _createBlock(_component_DialogLevelUp, {
          key: 0,
          isShowDialog: _ctx.isShowDialogLevelUp,
          customerId: _ctx.data.Id,
          onHideDialog: _ctx.hideLevelUpDialog,
          onProcessLevelup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.processSubmitLevelup(_ctx.dataForm.Id)))
        }, null, 8, ["isShowDialog", "customerId", "onHideDialog"]))
      : _createCommentVNode("", true)
  ]))
}